import { createAction, props } from '@ngrx/store';

export const setCurrencyList = createAction(
  'setCurrencyList',
  props<{ currencyList: string[] }>(),
);
